var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "vx-row mb-6" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "ripple",
                    rawName: "v-ripple.400",
                    value: "rgba(255, 255, 255, 0.15)",
                    expression: "'rgba(255, 255, 255, 0.15)'",
                    modifiers: { "400": true }
                  }
                ],
                staticClass: "mr-2",
                attrs: { variant: "primary" },
                on: {
                  click: function($event) {
                    _vm.showModal = true
                  }
                }
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-50",
                  attrs: { icon: "PlusIcon" }
                }),
                _c("span", { staticClass: "align-middle" }, [
                  _vm._v(_vm._s(_vm.$t("add")))
                ])
              ],
              1
            ),
            _c("vs-divider"),
            _c("Grid", {
              key: _vm.gridKey,
              ref: "dataAccessGrid",
              attrs: {
                service: _vm.dataAccessService,
                route_name: "data_accesses",
                route_grid_path: _vm.dataAccessesGridPath,
                hide_edit: "true",
                delegate: {
                  destroy: function() {
                    return _vm.removeRoleDataAccess
                  }
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "gridThead",
                  fn: function() {
                    return [
                      _c("vs-th", { key: "legal_entity_name" }, [
                        _vm._v("Instituição")
                      ]),
                      _c("vs-th", { key: "role_name" }, [_vm._v("Grupo")]),
                      _c("vs-th", { key: "role_description" }, [
                        _vm._v("Descrição Grupo")
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "gridActions",
                  fn: function() {
                    return [_c("vs-th", { key: "actions" }, [_vm._v("Ações")])]
                  },
                  proxy: true
                },
                {
                  key: "gridData",
                  fn: function(props) {
                    return _vm._l(props.data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr, attrs: { data: tr } },
                        [
                          _c("vs-td", { key: "id", attrs: { width: "30%" } }, [
                            _vm._v(
                              _vm._s(
                                tr.entity.legal_entity_name
                                  ? tr.entity.legal_entity_name
                                  : "--"
                              )
                            )
                          ]),
                          _c(
                            "vs-td",
                            { key: "role_name", attrs: { width: "20%" } },
                            [
                              _vm._v(
                                _vm._s(tr.entity && tr.entity.display_name)
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            {
                              key: "role_description",
                              attrs: { width: "40%" }
                            },
                            [_vm._v(_vm._s(tr.entity && tr.entity.description))]
                          ),
                          _c(
                            "vs-td",
                            { key: "actions", attrs: { width: "5%" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center"
                                },
                                [
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: {
                                          content: "Excluir",
                                          delay: { show: 1000, hide: 100 }
                                        },
                                        expression:
                                          "{\n                    content: 'Excluir',\n                    delay: { show: 1000, hide: 100 }\n                  }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    staticClass:
                                      "h-5 w-5 mb-1 stroke-current text-danger ",
                                    attrs: { icon: "Trash2Icon" },
                                    on: {
                                      click: function($event) {
                                        return props.destroy(
                                          props.data[indextr]
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "vs-popup",
        {
          attrs: { title: "Grupos", active: _vm.showModal },
          on: {
            "update:active": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [
          _vm.showModal
            ? _c("Grid", {
                attrs: {
                  service: _vm.roleService,
                  delegate: {
                    itemSelected: function() {
                      return _vm.addRoleDataAccess
                    }
                  },
                  route_name: "roles",
                  hide_actions: "true"
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }